import { Tr as ChakraTr } from "@chakra-ui/react";

export const Tr = ChakraTr;
